export default {
	obras: [],
	error: null,
	isFetching: false,
	// variáveis que controlam loading e modo do Drawer.
	action: '',
	actionFetching: false,
	actionError: false,
};
